import { render, staticRenderFns } from "./signup_vn.vue?vue&type=template&id=525a4647&scoped=true&"
import script from "./signup_vn.vue?vue&type=script&lang=js&"
export * from "./signup_vn.vue?vue&type=script&lang=js&"
import style0 from "./signup_vn.vue?vue&type=style&index=0&id=525a4647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525a4647",
  null
  
)

export default component.exports